import ResultsServiceCollection from '@/collections/ResultsServiceCollection'
import ResultModel from '@/models/result/ResultModel'

/**
 * Result collection
 */
export default class ResultCollection extends ResultsServiceCollection {

  // Model that is contained in this collection.
  model () {
    return ResultModel
  }

  getModelsFromResponse (response) {
    const models = []
    const { data } = response.getData()

    if (data.pagination) {
      this.set('count', data.pagination.total)
    }

    if (data.results) {
      data.results.forEach((insert) => {
        const temp = (new (this.model())(insert))
        models.push(temp)
      })
    }

    return models
  }

}
